(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["estudio-agenda"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('estudio-agenda')) return;
  class EstudioAgenda extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.previewThemeId = new URL(window.location.href).searchParams.get('preview_theme_id') || document.documentElement.dataset.esfPreviewThemeId || '';
      this.dataset.preview = String(Boolean(this.previewThemeId) || location.hostname.endsWith('.shopifypreview.com'));
      this.data = JSON.parse(this.querySelector('[data-esf-data]').textContent);
      const defaultPlans=this.data.plans;
      this.strings = JSON.parse(this.querySelector('[data-esf-strings]').textContent);
      const override = this.querySelector('[data-esf-override]');
      if (override) {
        try {
          const raw = JSON.parse(override.textContent);
          if (raw && raw.trim()) {
            const candidate = JSON.parse(raw);
            if (!this.validData(candidate)) throw new Error('Invalid schedule');
            this.data = candidate;
          }
        } catch (error) { console.error('Estudio: se conserva el horario base; revisa el JSON personalizado.', error); }
      }
      this.plans=this.data.plans||defaultPlans;
      this.state = {site:'Black',room:'',kind:'',limited:false,day:0,group:'',pricePeriod:'monthly'};
      this.week = this.querySelector('[data-week]');
      this.siteSelect = this.querySelector('[data-filter=site]');
      this.roomSelect = this.querySelector('[data-filter=room]');
      this.kindSelect = this.querySelector('[data-filter=kind]');
      this.dialog = this.querySelector('.esf-dialog');
      this.planDialog=this.querySelector('.esf-plan-dialog');
      this.querySelector('[data-plan-close]').addEventListener('click',()=>this.planDialog.close());
      this.planDialog.addEventListener('click',event=>{if(event.target===this.planDialog){const b=this.planDialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)this.planDialog.close();}});
      this.entry = this.querySelector('.esf-entry');
      this.main = this.querySelector('.esf-main');
      this.hasSelection = false;
      this.querySelectorAll('[data-enter-site]').forEach(button=>button.addEventListener('click',()=>this.selectSite(button.dataset.enterSite)));
      this.querySelectorAll('[data-switch-site]').forEach(button=>button.addEventListener('click',()=>this.selectSite(button.dataset.switchSite,true,false)));
      this.querySelectorAll('a[href^="#esf-"]').forEach(link=>link.addEventListener('click',()=>this.openSection(link.getAttribute('href').slice(1))));
      this.querySelectorAll('[data-change-site]').forEach(button=>button.addEventListener('click',()=>this.showEntrance()));
      this.entry.addEventListener('cancel',event=>{if(!this.hasSelection)event.preventDefault();});
      this.siteSelect.addEventListener('change',()=>this.selectSite(this.siteSelect.value,true,false));
      this.querySelectorAll('[data-method-group]').forEach(button=>button.addEventListener('click',()=>{
        this.querySelector('[data-class-directory]').open=true;
        this.state.group=button.dataset.methodGroup;
        this.querySelectorAll('[data-group]').forEach(x=>x.setAttribute('aria-pressed',String(x.dataset.group===this.state.group)));
        this.renderGuide();
        this.querySelector('[data-class-directory]').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});
      }));
      this.roomSelect.addEventListener('change', () => {this.state.room=this.roomSelect.value; this.render();});
      this.kindSelect.addEventListener('change', () => {this.state.kind=this.kindSelect.value; this.render();});
      this.querySelector('[data-filter=limited]').addEventListener('change', event => {this.state.limited=event.target.checked;this.render();});
      this.querySelector('[data-reset]').addEventListener('click', () => {
        Object.assign(this.state,{room:'',kind:'',limited:false,day:0});
        this.querySelector('[data-filter=limited]').checked=false;
        this.populateFilters();this.render();
      });
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const bounds=this.dialog.getBoundingClientRect();
        if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)this.dialog.close();
      });
      this.populateFilters();this.renderDays();this.renderGroups();this.renderGuide();this.render();this.renderPriceTabs();
      this.routeHandler=()=>this.route();
      window.addEventListener('popstate',this.routeHandler);
      this.route();
    }
    disconnectedCallback() {
      window.removeEventListener('popstate',this.routeHandler);
      this.initialized=false;
    }
    route() {
      const requested=new URL(window.location.href).searchParams.get('sede')?.toLowerCase();
      if(requested==='black'||requested==='gold')this.selectSite(requested==='gold'?'Gold':'Black',false,false);
      else {
        this.hasSelection=false;this.main.hidden=true;this.showEntrance();
      }
    }
    openSection(id) {
      const section=this.querySelector('#'+id);const fold=section?.querySelector('.esf-section-fold');if(fold)fold.open=true;
    }
    showEntrance() {
      if(!this.entry.open)this.entry.showModal();
    }
    selectSite(site,push=true,moveFocus=true) {
      if(!['Black','Gold'].includes(site))return;
      Object.assign(this.state,{site,room:'',kind:'',limited:false,day:0});
      this.dataset.site=site;this.hasSelection=true;this.main.hidden=false;
      this.siteSelect.value=site;
      this.querySelector('[data-filter=limited]').checked=false;
      this.querySelectorAll('[data-active-name],[data-current-site]').forEach(el=>el.textContent=site);
      this.querySelectorAll('[data-visible-site]').forEach(el=>{el.hidden=el.dataset.visibleSite!==site;});
      const shortcuts=this.querySelector('[data-room-shortcuts]');shortcuts.replaceChildren();
      this.data.rooms[site].forEach(room=>{
        const button=this.el('button','',room);button.type='button';
        button.addEventListener('click',()=>{
          this.state.room=room;this.roomSelect.value=room;this.render();
          this.openSection('esf-horarios');this.querySelector('.esf-calendar').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
        });
        shortcuts.append(button);
      });
      this.querySelectorAll('[data-switch-site]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.switchSite===site)));
      const number=site==='Black'?'56943997228':'56923964996';
      this.querySelector('[data-floating-wa]').href='https://wa.me/'+number+'?text='+encodeURIComponent('Hola, quisiera información de Estudio Sybellafit sede '+site+'.');
      this.querySelector('[data-wa-site]').textContent=site;
      this.querySelector('[data-floating-wa]').setAttribute('aria-label',this.strings.waContact+' · Sede '+site);
      this.querySelector('[data-floating-wa]').style.bottom='calc('+(this.dataset.preview==='true'?'94px':'24px')+' + env(safe-area-inset-bottom,0px))';
      this.querySelector('[data-program-wa]').href='https://wa.me/'+number+'?text='+encodeURIComponent('Hola, quisiera conocer días, horarios, cupos y valor del programa Fit Seniors en sede '+site+'.');
      this.populateFilters();this.render();this.renderGroups();this.renderGuide();this.renderPrices();
      if(this.entry.open)this.entry.close();
      if(push){
        const url=new URL(window.location.href);url.searchParams.set('sede',site.toLowerCase());url.hash='';
        if(this.previewThemeId)url.searchParams.set('preview_theme_id',this.previewThemeId);
        if(url.href!==window.location.href)history.pushState({...history.state,esfSede:site},'',url);
      }
      if(moveFocus){this.main.scrollIntoView({block:'start'});const heading=this.querySelector('h1');heading.tabIndex=-1;heading.focus({preventScroll:true});}
    }
    validData(data) {
      const rooms = {'Black':['Red','White','Black'],'Gold':['Glow','Space']};
      if(data?.plans && (!Array.isArray(data.plans)||!data.plans.every(p=>['Black','Gold'].includes(p.site)&&['monthly','limited','quarterly','annual'].includes(p.period)&&Number.isInteger(p.tokens)&&p.tokens>0&&Number.isFinite(p.price)&&p.price>0&&typeof p.name==='string')))return false;
      return data && data.rooms && Object.entries(rooms).every(([site,list])=>JSON.stringify(data.rooms[site])===JSON.stringify(list)) &&
        Array.isArray(data.classes) && data.classes.every(c=>['name','title','description','group'].every(k=>typeof c[k]==='string')) &&
        Array.isArray(data.events) && data.events.length<=2000 && data.events.every(e=>
        rooms[e.site]?.includes(e.room) && Number.isInteger(e.day) && e.day>=0 && e.day<=6 &&
        /^(?:[01]\d|2[0-3]):[0-5]\d$/.test(e.time) && typeof e.kind==='string' && e.kind.length<80);
    }
    el(tag,className,text) {
      const element=document.createElement(tag);
      if(className)element.className=className;
      if(text!==undefined)element.textContent=text;
      return element;
    }
    limited(event) {
      return event.day>=5 || (event.time>='10:00'&&event.time<='16:00');
    }
    filtered() {
      const s=this.state;
      return this.data.events.filter(e=>e.site===s.site&&(!s.room||e.room===s.room)&&(!s.kind||e.kind===s.kind)&&(!s.limited||this.limited(e)))
        .sort((a,b)=>a.day-b.day||a.time.localeCompare(b.time)||a.room.localeCompare(b.room));
    }
    populateFilters() {
      const s=this.strings;
      this.roomSelect.replaceChildren(new Option(s.allRooms,''));
      this.data.rooms[this.state.site].forEach(room=>this.roomSelect.add(new Option(room,room)));
      this.roomSelect.value=this.state.room;
      this.kindSelect.replaceChildren(new Option(s.allKinds,''));
      [...new Set(this.data.events.filter(e=>e.site===this.state.site).map(e=>e.kind))].sort().forEach(kind=>this.kindSelect.add(new Option(kind,kind)));
      this.kindSelect.value=this.state.kind;
    }
    renderDays() {
      const days=this.querySelector('[data-days]');
      this.strings.daysShort.forEach((day,index)=>{
        const b=this.el('button','',day);b.type='button';b.dataset.day=index;
        b.setAttribute('aria-label',this.strings.days[index]);
        b.addEventListener('click',()=>{this.state.day=index;this.render();});days.append(b);
      });
    }
    render() {
      const events=this.filtered(),s=this.strings,state=this.state;
      this.querySelectorAll('[data-site]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.site===state.site)));
      this.querySelectorAll('[data-day]').forEach(b=>b.setAttribute('aria-pressed',String(+b.dataset.day===state.day)));
      this.querySelector('[data-count]').textContent=events.length+' '+s.count;
      this.querySelector('[data-site-caption]').textContent=s.site+' '+state.site+' · '+(state.room||s.allRooms);
      this.querySelector('[data-empty]').hidden=events.length>0;
      this.week.replaceChildren();
      s.days.forEach((day,index)=>{
        const list=events.filter(e=>e.day===index);
        const column=this.el('section','esf-day'+(index===state.day?' esf-day-selected':''));
        column.setAttribute('aria-label',day);
        const heading=this.el('h3','esf-day-head',day);
        heading.append(this.el('span','',String(list.length)));column.append(heading);
        if(!list.length)column.append(this.el('p','esf-no-day',s.emptyDay));
        list.forEach(event=>{
          const b=this.el('button','esf-slot');b.type='button';b.dataset.room=event.room;
          b.setAttribute('aria-label',day+', '+event.time+', '+event.kind+', '+s.site+' '+event.site+', '+s.room+' '+event.room);
          b.append(this.el('span','esf-slot-time',event.time),this.el('span','esf-slot-kind',event.kind));
          const room=this.el('span','esf-slot-room');
          const dot=this.el('span','esf-dot');dot.setAttribute('aria-hidden','true');
          room.append(dot,document.createTextNode(event.room));b.append(room);
          b.addEventListener('click',()=>this.showDetail(event));column.append(b);
        });
        this.week.append(column);
      });
    }
    showDetail(event) {
      const s=this.strings,detail=this.data.classes.find(c=>c.name===event.kind);
      this.querySelector('[data-detail-site]').textContent=s.site+' '+event.site+' / '+s.room+' '+event.room;
      this.querySelector('[data-detail-title]').textContent=event.kind;
      this.querySelector('[data-detail-time]').textContent=s.days[event.day]+' · '+event.time;
      this.querySelector('[data-detail-description]').textContent=detail?.description||'';
      this.querySelector('[data-detail-level]').replaceChildren(this.levelBadge(detail||{}));
      this.querySelector('[data-detail-media]').replaceChildren();
      if(detail){const photo=this.classPhoto(detail,event.site);if(photo)this.querySelector('[data-detail-media]').append(photo);}
      const number=event.site==='Black'?'56943997228':'56923964996';
      const message='Hola, quiero consultar por '+event.kind+' del día '+s.days[event.day].toLowerCase()+' a las '+event.time+' en la sede '+event.site+', sala '+event.room+'.';
      this.querySelector('[data-detail-wa]').href='https://wa.me/'+number+'?text='+encodeURIComponent(message);
      this.dialog.showModal();
    }
    renderPriceTabs() {
      const labels={monthly:this.strings.monthly,limited:this.strings.limitedPlans,quarterly:this.strings.quarterly,annual:this.strings.annual};
      const container=this.querySelector('[data-price-tabs]');
      Object.entries(labels).forEach(([key,label])=>{
        const button=this.el('button','',label);button.type='button';button.dataset.pricePeriod=key;
        button.addEventListener('click',()=>{this.state.pricePeriod=key;this.renderPrices();});container.append(button);
      });
    }
    renderPrices() {
      const s=this.strings,site=this.state.site,period=this.state.pricePeriod;
      const suffix={monthly:s.priceMonth,limited:s.priceLimited,quarterly:s.priceQuarter,annual:s.priceYear};
      const grid=this.querySelector('[data-price-grid]');grid.replaceChildren();
      const formatter=new Intl.NumberFormat('es-CL',{style:'currency',currency:'CLP',maximumFractionDigits:0});
      this.querySelectorAll('[data-price-period]').forEach(x=>x.setAttribute('aria-pressed',String(x.dataset.pricePeriod===period)));
      this.plans.filter(p=>p.site===site&&p.period===period).forEach(plan=>{
        const card=this.el('article','esf-price-card');
        const name=plan.name?plan.name+' '+(period==='annual'?'Anual':'Trimestral'):`${plan.tokens} ${s.tokens}`;
        card.append(this.el('span','esf-price-site',`${s.site} ${site}`),this.el('h3','',name));
        if(plan.name)card.append(this.el('p','esf-price-tokens',`${plan.tokens} ${s.tokens}`));
        card.append(this.el('p','esf-price-amount',formatter.format(plan.price)),this.el('p','esf-price-period',suffix[period]));
        const tokenPrice=(plan.price-(plan.tokenCredit||0))/plan.tokens;
        const equivalent=this.el('div','esf-token-highlight');equivalent.append(this.el('strong','',formatter.format(tokenPrice)+' / clase'),this.el('span','',plan.tokenCredit?'Valor equivalente, descontando beneficios incluidos':'Valor del plan dividido por sus tokens'));
        card.append(equivalent);
        const benefits=this.el('ul','esf-card-benefits');
        (plan.benefits||[]).filter(line=>!line.startsWith(plan.tokens+' tokens')).forEach(line=>benefits.append(this.el('li','',line)));card.append(benefits);
        card.addEventListener('click',event=>{if(!event.target.closest('button,a'))this.showPlan(plan);});
        const link=this.el('button','esf-plan-cta',s.planContact+' ↗');link.type='button';
        link.addEventListener('click',()=>this.showPlan(plan));card.append(link);grid.append(card);
      });
      this.querySelector('[data-price-note]').textContent={monthly:s.monthlyNote,limited:s.limitedPriceNote,quarterly:s.quarterlyNote,annual:s.annualNote}[period];
      this.querySelector('[data-store-link]').href=(location.hostname.endsWith('.shopifypreview.com')?'https://www.sybellafit.com':'https://estudio.sybellafit.com')+'/collections/'+(site==='Black'?'estudo-sybellafit-black':'estudio-sybellafit-gold');
    }
    showPlan(plan) {
      const content=this.querySelector('[data-plan-content]');content.replaceChildren();
      const period={monthly:'Mensual',limited:'Limited mensual',quarterly:'Trimestral',annual:'Anual'}[plan.period];
      const name=plan.name?plan.name+' '+period:period;
      const heading=this.el('h2','',name+' · '+plan.site);heading.id='esf-plan-title';
      const amount=new Intl.NumberFormat('es-CL',{style:'currency',currency:'CLP',maximumFractionDigits:0}).format(plan.price);
      const months=plan.months||(plan.period==='annual'?12:plan.period==='quarterly'?3:1);
      content.append(heading,this.el('p','esf-plan-price',amount),this.el('p','esf-plan-subtitle','Valor base · '+period.toLowerCase()));
      const facts=this.el('div','esf-plan-facts');
      facts.append(this.el('strong','',plan.tokens+' tokens'),this.el('span','','Vigencia: '+(plan.validity||months+(months===1?' mes':' meses'))),this.el('span','',plan.site==='Gold'?'Sedes Black y Gold':'Sede Black'));
      content.append(facts);
      const limited=plan.limited||plan.period==='limited'||plan.name==='Limited';
      content.append(this.el('h3','','Tu horario'),this.el('p','esf-plan-hours',plan.hours||(limited?'Lunes a viernes, 10:00–16:00 h. Incluye fines de semana.':'Según horario de apertura de tu sede.')));
      const currency=n=>new Intl.NumberFormat('es-CL',{style:'currency',currency:'CLP',maximumFractionDigits:0}).format(n);
      const credit=plan.tokenCredit||0;
      const calculation=this.el('div','esf-token-calculation');
      calculation.append(this.el('strong','',currency((plan.price-credit)/plan.tokens)+' por token (clase)'),this.el('p','',credit?`(${currency(plan.price)} − $20.000 evaluación nutricional − $20.000 evaluación kinesiológica − $40.000 matrícula) ÷ ${plan.tokens} tokens`:`${currency(plan.price)} ÷ ${plan.tokens} tokens`),this.el('small','',credit?'Valor equivalente aproximado al descontar una evaluación de cada tipo y la matrícula incluidas. No reduce el precio a pagar.':'Valor aproximado sobre el precio base de la membresía. No se descuentan beneficios no incluidos.'));
      content.append(calculation);
      content.append(this.el('h3','','Todo esto es parte de tu plan'));
      const list=this.el('ul','esf-plan-benefits');
      (plan.benefits||['Acceso a clases dirigidas y Open Gym.','Agenda tus entrenamientos desde la app.']).forEach(text=>list.append(this.el('li','',text)));content.append(list);
      if(plan.enrollment)content.append(this.el('p','esf-plan-enrollment',plan.enrollment));
      content.append(this.el('p','esf-plan-terms','Reservas sujetas a cupos y condiciones de la membresía. '+(months===1?'Planes mensuales solo con suscripción. ':'')+'Confirma promociones vigentes y matrícula con el equipo.'));
      const link=this.el('a','esf-cta','Quiero este plan ↗');link.target='_blank';link.rel='noopener';
      link.href='https://wa.me/'+(plan.site==='Black'?'56943997228':'56923964996')+'?text='+encodeURIComponent(`Hola, quiero conocer las condiciones del plan ${name} de sede ${plan.site}: ${plan.tokens} tokens, ${months} meses, valor base ${amount}.`);
      content.append(link);this.planDialog.showModal();
    }
    levelBadge(item) {
      const box=this.el('div','esf-level');
      const level=Number(item.level);
      if(!level||level<1||level>3){box.textContent='Nivel: consulta al equipo';return box;}
      const label=level===1?'Todo nivel':level===1.5?'Inicial a intermedio':level===2?'Intermedio':level===2.5?'Intermedio a avanzado':'Avanzado';
      box.setAttribute('aria-label','Nivel '+String(level).replace('.',',')+' de 3 · '+label);
      const flames=this.el('span','esf-flames');flames.setAttribute('aria-hidden','true');
      for(let i=0;i<3;i++){const flame=this.el('span','esf-flame','♨');const fill=this.el('span','','♨');fill.style.width=Math.max(0,Math.min(1,level-i))*100+'%';flame.append(fill);flames.append(flame);}
      box.append(flames,this.el('span','','Nivel '+String(level).replace('.',',')+' · '+label));return box;
    }
    classPhoto(item,site=this.state.site) {
      const url=item.images?.[site];if(!url||!/^https:\/\/cdn\.shopify\.com\//.test(url))return null;
      const figure=this.el('figure','esf-class-photo');const img=this.el('img');img.src=url+(url.includes('?')?'&':'?')+'width=900';img.loading='lazy';img.width=768;img.height=512;
      img.alt=item.imageAlt||(item.illustrative?'Imagen ilustrativa de '+item.name+' en un espacio inspirado en el estudio':'Espacio de entrenamiento de sede '+site);
      figure.append(img);
      figure.append(this.el('figcaption','',item.illustrative?'Imagen ilustrativa · '+item.name:'Nuestros espacios · '+site));return figure;
    }
    renderGroups() {
      const groups=['',...new Set(this.data.classes.filter(c=>!c.sites||c.sites.includes(this.state.site)).map(c=>c.group))],container=this.querySelector('[data-groups]');container.replaceChildren();
      groups.forEach(group=>{
        const b=this.el('button','',group||this.strings.groupAll);b.type='button';b.dataset.group=group;
        b.setAttribute('aria-pressed',String(group===this.state.group));
        b.addEventListener('click',()=>{this.state.group=group;container.querySelectorAll('button').forEach(x=>x.setAttribute('aria-pressed',String(x.dataset.group===group)));this.renderGuide();});
        container.append(b);
      });
    }
    renderGuide() {
      const grid=this.querySelector('[data-class-grid]');grid.replaceChildren();
      this.data.classes.filter(c=>(!c.sites||c.sites.includes(this.state.site))&&(!this.state.group||c.group===this.state.group)).forEach((item,index)=>{
        const card=this.el('article','esf-class-card');
        const top=this.el('div','esf-class-top',item.group);top.append(this.el('span','',String(index+1).padStart(2,'0')));
        const photo=this.classPhoto(item);if(photo)card.append(photo);
        if(item.featured)card.append(this.el('span','esf-star','✦ Nuestra clase estrella'));
        card.append(top,this.el('h3','',item.name),this.el('p','esf-class-title',item.title),this.el('p','esf-class-description',item.description));
        card.append(this.levelBadge(item));if(item.focus)card.append(this.el('p','esf-class-focus',item.focus));
        const scheduled=this.data.events.some(e=>e.kind===item.name&&e.site===this.state.site);
        const b=this.el('button','',scheduled?this.strings.viewHours+' ↗':this.strings.notScheduled+' ↗');b.type='button';
        b.addEventListener('click',()=>{
          if(!scheduled){
            this.showDetail({site:this.state.site,room:this.data.rooms[this.state.site][0],kind:item.name,day:0,time:''});
            this.querySelector('[data-detail-time]').textContent=this.strings.notScheduled;
            this.querySelector('[data-detail-site]').textContent=this.strings.site+' '+this.state.site;
            const number=this.state.site==='Black'?'56943997228':'56923964996';
            this.querySelector('[data-detail-wa]').href='https://wa.me/'+number+'?text='+encodeURIComponent('Hola, quiero consultar por la disponibilidad de '+item.name+' en la sede '+this.state.site+'.');
            return;
          }
          const sameSite=this.data.events.find(e=>e.site===this.state.site&&e.kind===item.name);
          const first=sameSite;
          Object.assign(this.state,{site:first.site,room:'',kind:item.name,limited:false,day:first.day});
          this.querySelector('[data-filter=limited]').checked=false;this.populateFilters();this.render();
          this.openSection('esf-horarios');this.querySelector('.esf-calendar').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});
        });
        card.append(b);grid.append(card);
      });
    }
  }
  customElements.define('estudio-agenda',EstudioAgenda);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sybellafit-commerce"]) return;
  try {
    
document.querySelectorAll('[data-spf-variant]').forEach(select=>select.addEventListener('change',()=>{const url=new URL(window.location.href);url.searchParams.set('variant',select.value);if(new URL(location.href).searchParams.get('view')==='marca-preview')url.searchParams.set('view','marca-preview');window.location.assign(url.toString());}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sybellafit-personal"] && !Shopify.designMode) return;
  try {
    
(()=>{
 const openChapter=()=>{const id=location.hash.slice(1);const panel=document.getElementById(id);if(panel?.matches('.spf-chapter'))panel.open=true;};
 document.querySelectorAll('[data-spf-open-mentor]').forEach(link=>link.addEventListener('click',()=>{const panel=document.getElementById('spf-mentorias');if(panel)panel.open=true;}));
 addEventListener('hashchange',openChapter);openChapter();
})();

  } catch(e) { console.error(e); }
})();
})();
